import { Component, OnInit } from '@angular/core';
import { NgProgress, NgProgressRef } from 'ngx-progressbar';
import { Subscription } from 'rxjs';
import { ConfirmActionComponent } from 'src/app/components/dialog/confirm/confirm-action/confirm-action.component';
import { PaginationInput, PaginationPageEvent, ListParams, Res } from 'src/app/models';
import { DialogModalService, LanguageService, NotificationService } from 'src/app/services';
import { PublicApiServiceService } from 'src/app/services/integrations/public-api/public-api-service.service';

@Component({
  selector: 'app-public-api',
  templateUrl: './public-api.component.html',
  styleUrls: ['./public-api.component.css']
})
export class PublicApiComponent implements OnInit {

  progressRef: NgProgressRef;
  subscriptions: Subscription = new Subscription();
  language: string;
  loading: boolean;
  apiList: any[] = [];
  paginationInput: PaginationInput;
  paginationOutput: PaginationPageEvent;
  listParams: ListParams;

  constructor(
    public ngProgress: NgProgress,
    private languageService: LanguageService,
    private apiService: PublicApiServiceService,
    private dialogModal: DialogModalService,
    private notification: NotificationService
  ) { }

  ngOnInit(): void {

    this.progressRef = this.ngProgress.ref('progress-bar');

    this.getList();

    this.subscriptions.add(
      this.languageService.listenerLanguage().subscribe(val => {

        this.language = val.language;
      })
    );
  }

  ngOnDestroy(): void {

    this.subscriptions.unsubscribe();
  }

  /**
  * 
  */
  getList(): void {

    this.progressRef.start();
    this.loading = true;
    this.apiList = [];

    this.setListParams();

    this.apiService.getList(this.listParams).subscribe((response: Res) => {
      console.log('[RESPONSE] getApiList: ', response);


      if (response != null) {

        if (response.result != null) {

          this.apiList = response.result.list;

          this.paginationInput = {
            count: response.result.count,
            numberOfPages: response.result.numberOfPages,
            currentPage: this.listParams.pageNumber,
            size: this.listParams.countOnPage
          }
        }
      }

      this.progressRef.complete();
      this.loading = false;
    },
      error => {
        this.progressRef.complete();
        this.loading = false;
      });
  }

  /**
 * 
 */
  setListParams(): void {

    this.listParams = {
      filter: {
        org_id: ''
      },
      pageNumber: (!this.paginationOutput || this.paginationOutput == undefined || this.paginationOutput == null) ? 1 : this.paginationOutput.pageNumber,
      countOnPage: (!this.paginationOutput || this.paginationOutput == undefined || this.paginationOutput == null) ? 10 : this.paginationOutput.pageSize
    }
  }

  /**
   * 
   * @param event 
   */
  pageEvent(event: PaginationPageEvent): void {

    this.paginationOutput = event;
    this.getList();
  }

  /**
  * 
  */
  generateApi(): void {

    this.progressRef.start();

    let data = {};

    this.subscriptions.add(
      this.apiService.generateLink(data).subscribe(response => {
        console.log('[RESPONSE] generateApi: ', response);

        if (response != null) {

          this.notification.show('success', 'Данные успешно добавлены!');
          this.getList();
        }

        this.progressRef.complete();
      })
    );
  }
  
   /**
  * 
  * @param ids 
  */
   onConfirm(ids: string[]) {

    let message = 'Вы действительно хотите удалить?';

    this.dialogModal.open(message, ConfirmActionComponent, '', 'confirmAction-window').then(
      (result) => {

        if (result) {

          this.onDelete(ids);
        }
      },
      () => { console.log('Rejected!'); }
    );

  }

  /**
  * 
  * @param ids 
  */
  onDelete(ids: string[]): void {

    this.progressRef.start();

    this.subscriptions.add(
      this.apiService.delete({ id: ids }).subscribe(response => {

        if (response != null) {

          this.getList();

          this.notification.show('success', 'Данные успешно удалены!');
        }

        this.progressRef.complete();
      })
    );
  }

  /**
   * 
   * @param link 
   */
  copyLink(link: string) {

    let listener = (e: ClipboardEvent) => {
      e.clipboardData.setData('text/plain', (link));
      e.preventDefault();
    };

    document.addEventListener('copy', listener);
    document.execCommand('copy');
    document.removeEventListener('copy', listener);

    this.notification.show('success', 'Данные успешно скопированы в буфер!');
  }

}
